var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.19189 12.5972H12.8008C13.4893 12.5972 13.9067 12.2383 13.9067 11.7109C13.9067 10.9785 13.1597 10.3193 12.5298 9.66748C12.0464 9.16211 11.9146 8.12207 11.856 7.27978C11.8047 4.46729 11.0576 2.52637 9.10937 1.82324C8.83105 0.871094 8.07666 0.109375 6.99268 0.109375C5.91602 0.109375 5.1543 0.871094 4.8833 1.82324C2.93506 2.52637 2.18799 4.46729 2.13672 7.27978C2.07812 8.12207 1.94629 9.16211 1.46289 9.66748C0.825684 10.3193 0.0859375 10.9785 0.0859375 11.7109C0.0859375 12.2383 0.496094 12.5972 1.19189 12.5972ZM6.99268 15.5269C8.23779 15.5269 9.146 14.6187 9.24121 13.5933H4.75146C4.84668 14.6187 5.75488 15.5269 6.99268 15.5269Z",
    fill: "#E5E4EC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBell);
export default __webpack_public_path__ + "static/media/icon-bell.5eba39f2984cb44b1bb9c2e9bedabcf8.svg";
export { ForwardRef as ReactComponent };